// import rellax from 'rellax';
export default class graduatesFilter {
	constructor(scrollList, filterForm, rell) {
		this.self = this;
		this._init(scrollList, filterForm, this, rell);
	}

	getCheckedBoxes(chkboxName) {
		var checkboxes = document.getElementsByName(chkboxName);
		var checkboxesChecked = [];
		// loop over them all
		for (let i = 0; i < checkboxes.length; i++) {
			// And stick the checked ones onto an array...
			if (checkboxes[i].checked) {
				checkboxesChecked.push(checkboxes[i]);
			}
		}
		// Return the array if it is non-empty, or null
		return checkboxesChecked.length > 0 ? checkboxesChecked : null;
	}

	getYearsToHide(yearsValue, item, dataItemsToHide) {
		if (yearsValue && yearsValue !== '') {
			let year = item.getAttribute('data-year');
			if (yearsValue !== year.toString()) {
				let id = item.getAttribute('data-id');
				dataItemsToHide.push(id);
			}
		}
	}

	getCheckboxValuesToHide(
		checkboxList,
		item,
		compareAttribute,
		dataItemsToHide,
		checkboxValueDone
	) {
		let val = item.getAttribute(compareAttribute).toLowerCase();
		let shouldHide = true;
		if (checkboxList && checkboxList.length > 0) {
			for (var i = 0; i < checkboxList.length; i++) {
				let checkBox = checkboxList[i];
				let va = checkboxValueDone
					? checkBox.toLowerCase()
					: checkBox.value.toLowerCase();

				if (va === val) {
					shouldHide = false;
				}
			}

			if (shouldHide) {
				let id = item.getAttribute('data-id');
				dataItemsToHide.push(id);
			}
		}
	}

	getSearchedValueToHide(searchValue, item, dataItemsToHide) {
		let id = item.getAttribute('data-id');
		let searchedValue = item.getAttribute('data-searchname');
		if (searchValue) {
			if (searchValue.trim() !== '') {
				if (!searchedValue.toLowerCase().includes(searchValue.toLowerCase())) {
					dataItemsToHide.push(id);
				}
			}
		}
	}

	setFilterSessionStorage(search, year, programme, studyLvl) {
		let programmeArr = [];
		let studyLvlArr = [];
		if (programme) {
			for (let index in programme) {
				let prog = programme[index];
				programmeArr.push(prog.value);
			}
		}
		if (studyLvl) {
			for (let indexStudy in studyLvl) {
				let studyLevel = studyLvl[indexStudy];
				studyLvlArr.push(studyLevel.value);
			}
		}
		let filter = {
			search: search,
			year: year,
			programme: programmeArr,
			studyLvl: studyLvlArr,
		};
		sessionStorage.setItem('graduateFilter', JSON.stringify(filter));
	}

	setFormElementsUIFromStorage(savedGraduateFilter) {
		//check programme
		if (
			savedGraduateFilter.programme &&
			savedGraduateFilter.programme.length > 0
		) {
			for (let i = 0; i < savedGraduateFilter.programme.length; i++) {
				let programme = savedGraduateFilter.programme[i];
				if (programme.toLowerCase() === 'textile') {
					let textileCheckbox = document.querySelector('#TextileDesign');
					textileCheckbox.checked = true;
				}

				if (programme.toLowerCase() === 'fashion') {
					let fashionCheckBox = document.querySelector('#FashionDesign');
					fashionCheckBox.checked = true;
				}
			}
		}

		if (
			savedGraduateFilter.studyLvl &&
			savedGraduateFilter.studyLvl.length > 0
		) {
			for (let i = 0; i < savedGraduateFilter.studyLvl.length; i++) {
				let studyLevel = savedGraduateFilter.studyLvl[i];
				if (studyLevel.toLowerCase() === 'bachelor') {
					let bachelorCheckbox = document.querySelector('#Bachelor');
					bachelorCheckbox.checked = true;
				}
				if (studyLevel.toLowerCase() === 'master') {
					let masterCheckBox = document.querySelector('#Master');
					masterCheckBox.checked = true;
				}
			}
		}

		if (savedGraduateFilter.year) {
			let yearsDropdown = document.querySelector('#years');
			yearsDropdown.value = savedGraduateFilter.year;
		}
		if (savedGraduateFilter.search) {
			let seaerchBarValue = document.querySelector('#searchbar-graduates');
			seaerchBarValue.value = savedGraduateFilter.search;
		}
	}

	filterItems(
		filterItems,
		yearsValue,
		seaerchBarValue,
		checkedProgramme,
		checkedStudyLevel,
		dataItemsToHide,
		classElement,
		checkboxesDone,
		rell
	) {
		//add the ids that should be shown to a list
		for (var i = 0; i < filterItems.length; i++) {
			var item = filterItems[i];
			classElement.getYearsToHide(yearsValue, item, dataItemsToHide);
			//Get checked element for programme
			classElement.getCheckboxValuesToHide(
				checkedProgramme,
				item,
				'data-programme',
				dataItemsToHide,
				checkboxesDone
			);
			//Get checked element for study level
			classElement.getCheckboxValuesToHide(
				checkedStudyLevel,
				item,
				'data-studylevel',
				dataItemsToHide,
				checkboxesDone
			);
			classElement.getSearchedValueToHide(
				seaerchBarValue,
				item,
				dataItemsToHide
			);
		}

		//Loop through the list and set display none on the ids thats not in the list
		let index = 1;
		for (var ind = 0; ind < filterItems.length; ind++) {
			var itemToShow = filterItems[ind];
			if (dataItemsToHide.indexOf(itemToShow.getAttribute('data-id')) > -1) {
				itemToShow.style.display = 'none';
			} else {
				itemToShow.style.display = '';
				classElement.moveItem(itemToShow, index, classElement);
				index++;
				if (index === 4) {
					index = 1;
				}
			}
		}

		rell.refresh();
	}

	moveItem(itemToShow, index, classElement) {
		let scrollArea = document.getElementById('scrollable-' + index);

		let scrollRelaxArea = scrollArea.getElementsByClassName('rellax')[0];

		let elementToMove = itemToShow;
		itemToShow.remove();
		scrollRelaxArea.appendChild(elementToMove);

		classElement.fadeIn(elementToMove, 2000);
	}

	fadeIn(el, time) {
		el.style.opacity = 0;

		var last = +new Date();
		var tick = function() {
			el.style.opacity = +el.style.opacity + (new Date() - last) / time;
			last = +new Date();

			if (+el.style.opacity < 1) {
				(window.requestAnimationFrame && requestAnimationFrame(tick)) ||
					setTimeout(tick, 16);
			}
		};

		tick();
	}

	_init(scrollList, filterForm, classElement, rell) {
		let filterItems = scrollList.querySelectorAll('[data-isgraduate]');
		let dataItemsToHide = [];

		let savedGraduateFilter = JSON.parse(
			window.sessionStorage.getItem('graduateFilter')
		);

		//Do the filtering from sessionStorage
		if (savedGraduateFilter) {
			let filter = savedGraduateFilter;
			classElement.setFormElementsUIFromStorage(filter);
			classElement.filterItems(
				filterItems,
				savedGraduateFilter.year,
				savedGraduateFilter.search,
				savedGraduateFilter.programme,
				savedGraduateFilter.studyLvl,
				dataItemsToHide,
				classElement,
				true,
				rell
			);
		}

		filterForm.addEventListener('change', function() {
			dataItemsToHide = [];
			//Get checked checkboxes from programme and study level
			let checkedProgramme = classElement.getCheckedBoxes('Programme');
			let checkedStudyLevel = classElement.getCheckedBoxes('studylvl');

			//Get chosen year
			let yearsDropdown = document.querySelector('#years');
			let yearsValue = yearsDropdown.innerHTML;
			//Get searchstring
			let seaerchBarValue = document.querySelector('#searchbar-graduates')
				.value;

			if (yearsValue === 'All years') {
				yearsValue = '';
			}

			//Do the filtering
			classElement.filterItems(
				filterItems,
				yearsValue,
				seaerchBarValue,
				checkedProgramme,
				checkedStudyLevel,
				dataItemsToHide,
				classElement,
				false,
				rell
			);

			//Save the filter
			classElement.setFilterSessionStorage(
				seaerchBarValue,
				yearsValue,
				checkedProgramme,
				checkedStudyLevel
			);
		});
	}
}
